export default {
    DATA_LOADED: 'MCH_DATA_LOADED',
    AXESRANGESCHANGED: 'MCH_AXESRANGESCHANGED',
    CLEAR_CHART_STATE: 'MCH_CLEAR_CHART_STATE',
}


// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart/action-types.js